import React from "react";
import { Tag } from "@flixbus/honeycomb-react";
import type { ChipTagProps } from "../CompositionChip/CompositionChip.types";

const VariableTag: React.FC<ChipTagProps> = ({ label, closeProps }) => (
  <Tag display="subtle" appearance="success" closeProps={closeProps}>
    {label}
  </Tag>
);

export default VariableTag;
